import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import { menuItems } from './menuItems'; // menuItems를 별도로 관리할 수도 있습니다.

const menuItems = [
    {
        id: "ctrl",
        label: "통합관제",
        className: "ctrl",
        path: "/module/integratedControlView",
        viewType: "integratedControl"
    },
    {
        id: "trfFlow",
        label: "도로소통",
        className: "trfFlow",
        path: "/module/roadTrafficView",
        viewType: "roadTraffic"
    },
    {
        id: "sgnl",
        label: "신호운영",
        className: "sgnl",
        //   path: "/module/signalOperationView",
        //   viewType: "signalOperation"
        path: "/module/SignalOperationViewTest",
        viewType: "SignalOperationViewTest"
    },
    {
        id: "bus",
        label: "버스운행",
        className: "bus",
        path: "/module/busOperationView",
        viewType: "busOperation"
    },
    {
        id: "sfty",
        label: "교통안전",
        className: "sfty",
        path: "/module/trafficSafetyView",
        viewType: "trafficSafety"
    },
    {
        id: "future",
        label: "미래교통",
        className: "future",
        path: "/module/futureTransportationView",
        viewType: "futureTransportation"
    },
];

const useNavigation = (mapMessages) => {
  const navigate = useNavigate();
  const location = useLocation();
  const lastConsumedRef = useRef(null); // 마지막 처리한 메시지 기억

  useEffect(() => {
    const latest = mapMessages.at(-1);
    if (!latest) return;

    // 메시지가 VIEW_CHANGED:로 시작하지 않거나, 이전에 처리한 메시지이면 무시
    if (!latest.startsWith("VIEW_CHANGED:") || lastConsumedRef.current === latest) return;

    const [, viewType] = latest.split(":");
    const matchedMenu = menuItems.find(item => item.viewType === viewType);
    if (matchedMenu && location.pathname !== matchedMenu.path) {
      lastConsumedRef.current = latest; // 처리된 메시지 기억
      navigate(matchedMenu.path);
    }
  }, [mapMessages, location.pathname, navigate]);
};

export default useNavigation;